import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { CreateProjectAction, CreateWorkbookAction } from '~src/spacesPlatform/components/Explorer/CreateContent/CreateContentActionsList';
import { CreateContentButtonLocations } from '~src/spacesPlatform/components/Explorer/CreateContent/CreateContentButton';

import { getAppStore } from '../../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../../codegen/Localize';

export function newWorkbookButton(): JSX.Element {
  const appState = getAppStore().getState();
  const createWorkbookAction = CreateWorkbookAction;
  if (createWorkbookAction.isVisible(appState, 'workbook', CreateContentButtonLocations.SiteSpace) && createWorkbookAction.isClickable(appState)) {
    const reduxAction = createWorkbookAction.createReduxAction();
    const handleClick = () => getAppStore().dispatch(reduxAction);
    return (
      <ButtonWidget
        children={Messages.newWorkbook()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        testId={'action-new-workbook'}/>
    );
  }
  return null;
}

export function newProjectButton(): JSX.Element {
  const appState = getAppStore().getState();
  const createProjectAction = CreateProjectAction;
  if (createProjectAction.isVisible(appState, 'project', CreateContentButtonLocations.SiteSpace) && createProjectAction.isClickable(appState)) {
    const reduxAction = createProjectAction.createReduxAction();
    const handleClick = () => getAppStore().dispatch(reduxAction);
    return (
      <ButtonWidget
        children={Messages.newProject()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        testId={'action-new-project'}/>
    );
  }
  return null;
}
